import  firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyB8UW9DQg9OII9Hz1lAZUgu-izvQ29U9J8",
    authDomain: "stopshop-3c15d.firebaseapp.com",
    projectId: "stopshop-3c15d",
    storageBucket: "stopshop-3c15d.appspot.com",
    messagingSenderId: "987208344281",
    appId: "1:987208344281:web:8f50f28f65b528e613d4c8"
  };

  firebase.initializeApp(firebaseConfig);
  const auth = firebase.auth();
  const db = firebase.firestore();
  const storage = firebase.storage();

  export  {auth, db, storage};

